import PrescriptionFillsContainer from './prescription-fills-container';

export default PrescriptionFillsContainer;
